import axios from 'axios';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5001').replace(/\/api$/, '');

export interface SetFieldRequest {
  /** Entity row id (e.g. work order line id). */
  id: string;
  /** Column id whose backing field to update. Allowlisted on the backend. */
  field: string;
  /** Stringified value. Backend coerces to the target field's type. */
  value: string;
}

export async function setFieldApi(token: string | null, body: SetFieldRequest): Promise<void> {
  await axios.put(`${API_URL}/api/netsuite/set-field`, body, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}
